<template>
  <div>
    <!-- suggests for brand found message -->
    <v-snackbar top color="success" v-model="brandFound">    
      <v-icon>mdi-check-circle-outline</v-icon> <span class="font-weight-bold pl-2">There are suggests for this brand!</span>    
    </v-snackbar>
    <!-- no suggests for brand found message -->
    <v-snackbar top color="#fcba03" v-model="noBrandFound">    
      <v-icon>mdi-alert-circle-outline</v-icon> <span class="font-weight-bold pl-2">Google does not offer any suggests for this brand!</span>    
    </v-snackbar>
    <v-container
      id="allresearches"
      fluid
      tag="section">
      <v-row>
        <v-col cols="12" sm="6" md="3" xl='3'>
          <v-card class="px-5 py-3" id="kwcountCard">
            <v-row>
              <v-sheet
                color="primary"
                max-height="50"
                class="pa-12"
                dark
                top
                id="searchsheet"
                rounded
                elevation='6'>
                  <div class='headingsheet2'>
                    <v-icon id="sheeticon" :light="this.$vuetify.theme.dark ? true : false" large>mdi-office-building-outline</v-icon>
                  </div>
              </v-sheet>
              <div class="ml-auto text-right">
                <div class="body-3 grey--text font-weight-light">Companies</div>
                <div > {{ dbCount }} </div>
                <div v-for="status in dbCountStati" :key="status.status">
                  {{ status.count }} {{ status.status }}
                </div>
              </div>
            </v-row>
            <v-col cols="12" class="px-0 pb-1">
              <v-divider />
            </v-col>
            <div class="text-right">
              <v-btn elevation="2" color="primary" to="/admin/companies"><v-icon left dark>mdi-launch</v-icon>switch to companies</v-btn>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="3" xl='3'>
          <v-card class="px-5 py-3" id="kwcountCard">
            <v-row>
              <v-sheet
                color="primary"
                max-height="50"
                class="pa-12"
                dark
                top
                id="searchsheet"
                rounded
                elevation='6'>
                  <div class='headingsheet2'>
                    <v-icon id="sheeticon" :light="this.$vuetify.theme.dark ? true : false" large>mdi-account-group-outline</v-icon>
                  </div>
              </v-sheet>
              <div class="ml-auto text-right">
                <div class="body-3 grey--text font-weight-light">Users</div>
                <div > {{ userCount }} </div>
              </div>
            </v-row>
            <v-col cols="12" class="px-0 pb-1">
              <v-divider />
            </v-col>
            <div class="text-right">
              <v-btn elevation="2" color="primary" to="/admin/user"><v-icon left dark>mdi-launch</v-icon>switch to user</v-btn>
            </div>
          </v-card>
        </v-col>
          <v-col cols="12" sm="6" md="3" xl='3'>
          <v-card class="px-5 py-3" id="kwcountCard">
            <v-row>
              <v-sheet
                color="primary"
                max-height="50"
                class="pa-12"
                dark
                top
                id="searchsheet"
                rounded
                elevation='6'>
                  <div class='headingsheet2'>
                    <v-icon id="sheeticon" :light="this.$vuetify.theme.dark ? true : false" large>mdi-source-pull</v-icon>
                  </div>
              </v-sheet>
              <div class="ml-auto text-right">
                <div class="body-3 grey--text font-weight-light">DataForSEO Requests</div>
                <div > {{ requestsCount }} </div>
              </div>
            </v-row>
            <v-col cols="12" class="px-0 pb-1">
              <v-divider />
            </v-col>
            <div class="text-right">
              <!-- <v-btn elevation="2" color="primary" to="/admin/users"><v-icon left dark>mdi-launch</v-icon>switch to user</v-btn> -->
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
       <v-col cols="12" sm="12" md="6" id="main">
            <v-card class="px-5 py-3 rounded-card">
                <v-row>
                  <v-sheet
                    color="primary"
                    max-height="50"
                    class="pa-12"
                    dark
                    top
                    id="tablesheet"
                    rounded
                    elevation='6'  
                    >    
                    <div class='headingsheet2'>  
                        <v-icon id="sheeticon" large>mdi-file-table </v-icon> 
                    </div>

                </v-sheet>

                <v-card-title id="heading3">
                  Find Suggests for Brand Dashboard
                </v-card-title>

                </v-row>
                <v-card-text>
                    <v-row>
                        <v-col>
                            
                            <v-text-field   
                                label="Brand Name"
                                v-model="brand"
                                required
                                prepend-icon="mdi-pencil-box"
                            ></v-text-field> 
                        </v-col>
                        <v-col xs12 id="kwpformflex">
                            <v-select
                                v-model="searchvolumeFrom"
                                :items="searchvolumeFromItems"
                                item-text="value"                          
                                label="country for searchvolume"
                                prepend-icon="mdi-map-marker"
                                return-object
                                overflow
                                attach>
                            </v-select>
                        </v-col>
                    </v-row>                           
                </v-card-text>
                 <v-card-actions>
                    <v-btn @click="findSuggests()" :disabled="btnDisabled" class="mx-auto" large dark color="primary">find suggests</v-btn>
                </v-card-actions>
                <v-progress-linear
                  v-if="btnDisabled"
                  indeterminate
                  color="cyan"
                ></v-progress-linear>
              
            </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- <v-row justify="center">
      <v-col cols="10">
        <v-expansion-panels inset>
          <v-expansion-panel
            key="1">
            <v-expansion-panel-header>
              <v-row>
                <v-img src="@/assets/user-illustration.svg" id="userimage"></v-img>
                <span id="paneltitle" class="mt-5">All Companies</span> 
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              BLUUUUB
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>



  export default {
    name: 'AdminMonitoring',
 

    data: () => ({
      brand: "",
      searchvolumeFrom: {lang: "1001", loc: "2276", value: "Germany" },
      searchvolumeFromItems: [
          {lang: "1001", loc: "2276", value: "Germany" }, 
          // {lang: "1001", loc: "2040", value: "Austria" },
          // {lang: "1001", loc: "2756", value: "Switzerland" },
          // {lang: "1000", loc: "2826", value: "United Kingdom" },
          // {lang: "1004", loc: "2380", value: "Italy" },
          // {lang: "1030", loc: "2616", value: "Poland" },
          // {lang: "1031", loc: "2643", value: "Russia" },
          // {lang: "1039", loc: "2191", value: "Croatia"},
          // {lang: "1021", loc: "2203", value: "Czechia" },
          // {lang: "1033", loc: "2703", value: "Slovakia"},
          // {lang: "1034", loc: "2705", value: "Slovenia" },
          // {lang: "1024", loc: "2348", value: "Hungary" },
          // {lang: "1002", loc: "2250", value: "France" },
      ], 
      btnDisabled: false,
      brandFound: false,
      noBrandFound: false,


      userCount: undefined,
      dbCount: undefined,
      dbCountStati: [],
      requestsCount: undefined,
      auth: "Basic " + window.btoa(process.env.VUE_APP_AUTH),
    }),
    methods: {
      fetchStats() {
        this.$http.get(process.env.VUE_APP_APIURL+'/admin/monitoring/stats', { headers: {'Authorization': this.auth}})
          .then(function(response){
            console.log(response)
            this.userCount = response.body.userCount
            this.requestsCount = response.body.requestsCount
            this.dbCount = response.body.dbCount
            this.dbCountStati = response.body.dbCountStati
          //   let stats = {};
          //   this.collectionCount= response.body.stats.count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."); 
          //   this.collectionSize = (response.body.stats.storageSize/1014).toFixed(2) + " MB";
          });
      },
      findSuggests() {
        if(this.brand.length > 0){
          this.btnDisabled = true
          let postData = {
            keyword: this.brand,
            langloc: this.searchvolumeFrom,
            user: "admin dashboard",
            company: 1

          }
          this.$http.post(process.env.VUE_APP_APIURL+'/sources/dataforseo/suggests',postData, { headers: {'Authorization': this.auth}})
            .then(function(response){
              console.log(response)
              this.btnDisabled = false
              if(!response.body){
                this.noBrandFound= true
              }else{
                this.brandFound = true
              }
              
          });
        }
        
      },
    
    
    },
    created: function(){
      this.fetchStats();
    },
  }
</script>
<style lang="css" scoped>
.headingsheet2{
  margin-top: -15px;
}
#searchsheet{
  margin-top: -30px;
  margin-left:5px;
  width: 30px;
  height: 30px;
}

#sheeticon{
    margin-left: -25px;
    margin-top: -25px;
    margin: auto !important;
    padding-bottom: 50% !important;
    width: 50% !important;
}

#kwcountCard {
  padding-bottom: 10px !important;
}

.v-application .pa-12 {
    padding: 50px !important;
}

#allresearches{
    padding-top: 30px;
    margin-top: -10px;
}
#listnameColumn{
  font-size: 1.1em;
}
#sheeticon{
    margin-left: -25px;
    margin-top: -25px;
    margin: auto !important;
    padding-bottom: 50% !important;
    width: 50% !important;
}
#heading3{
  font-weight: 300!important;
  color: rgb(105, 105, 105);
}
</style>


